const getTriggerPollBlockedMessage = ({ trigger } = {}) => {
  const error = trigger?.details?.pollError;
  if (trigger?.triggerType !== 'long_poll' || !error) {
    return null;
  }
  const actionName = String(trigger.actionLabel || trigger.actionId || 'This trigger').trim();
  if (error === 'TRIGGER_POLL_INCOMPLETE') {
    return actionName + ' could not read all matching records. Its app trigger needs pagination or a narrower source before polling can continue.';
  }
  if (['TRIGGER_ACTION_EVENT_DETECTION_MISSING', 'TRIGGER_RESPONSE_INVALID', 'TRIGGER_POLL_SOURCE_INVALID', 'TRIGGER_DATE_FIELD_MISSING', 'TRIGGER_DATE_FORMAT_INVALID', 'TRIGGER_ENRICHMENT_INVALID', 'TRIGGER_QUERY_UNSUPPORTED', 'TRIGGER_QUERY_NOT_PUSHABLE'].includes(error)) {
    return actionName + ' needs its app trigger configuration repaired and tested with real records before it can fire.';
  }
  return actionName + ' could not complete its last poll. Check the connection and poll error (' + error + ').';
};

export default getTriggerPollBlockedMessage;
